<div class="standard-colorpicker-container field">
    <input
        #colorpicker
        [colorPicker]="data()"
        (colorPickerChange)="onColorPickerChanged($event)"
        cpAlphaChannel="disabled"
        cpOutputFormat="hex"
        class="standard-colorpicker"
        [disabled]="disabled()"
        [placeholder]="label()"
        [ngModel]="data()"
        (ngModelChange)="data.set($event)"
        (input)="onInput()"
        (change)="onChange()"
        (blur)="onTouchedFn()"
        [id]="id"
        [name]="id"
        [cpCmykEnabled]="true"
        (colorPickerSelect)="onColorPickerSelect($event, data())"
        [cpOKButton]="true"
    />

    <div class="standard-colorpicker-color-preview" [style.background]="data()"></div>

    <label [for]="id" class="standard-colorpicker-caption">{{ label() }}</label>

    @if (hint()?.length) {
        <small class="form-text text-muted d-block mt-1"><i class="far fa-hand-point-right"></i>{{ hint() }}</small>
    }

    @if (control?.invalid && (control?.dirty || control?.touched)) {
        <div class="form-text text-danger">
            @if (control?.errors?.required) {
                <div><i class="fas fa-exclamation-circle"></i>{{ 'defaults.validation.nameRequired' | translation: { name: label() } | async }}</div>
            }
            @if (control?.errors?.maxlength) {
                <div>
                    <i class="fas fa-exclamation-circle"></i>
                    {{ 'defaults.validation.maxlength' | translation: { name: label(), requiredLength: control?.errors?.maxlength.requiredLength } | async }}
                </div>
            }
            @if (control?.errors?.minlength) {
                <div>
                    <i class="fas fa-exclamation-circle"></i>
                    {{ 'defaults.validation.minlength' | translation: { name: label(), requiredLength: control?.errors?.minlength.requiredLength } | async }}
                </div>
            }
            @if (validationError()?.length) {
                <div><i class="fas fa-exclamation-circle"></i>{{ validationError() }}</div>
            }
        </div>
    }
</div>
